import React from "react";
import styled from "styled-components";

const Options = (props) => {
  const options = [
    {
      text: "Support",
      handler: props.actionProvider.handleSupportOption,
      id: 1,
    },
    {
      text: "Pricing",
      handler: props.actionProvider.handlePricingOption,
      id: 2,
    },
    {
      text: "Contact",
      handler: props.actionProvider.handleContactOption,
      id: 3,
    },
  ];

  const buttonsMarkup = options.map((option) => (
    <button key={option.id} onClick={option.handler} className="optionName">
      {option.text}
    </button>
  ));

  return <OptionContainer>{buttonsMarkup}</OptionContainer>;
};

export default Options;

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 15px;
  .optionName {
    padding: 5px 10px;
    border: 2px solid rgb(58, 170, 53);
    color: rgb(32, 32, 79);
    font-weight: 500;
    font-size: 16px;
    border-radius: 8px;
    margin-right: 8px;
    margin-bottom: 10px;
    cursor: pointer;
  }
`;
